import { LegalLayout } from "../components/LegalLayout";

export default function PrivacyPolicy() {
  return (
    <LegalLayout title="Privacy Policy" updated="Giugno 2026" testId="privacy-policy-page">
      <p>
        La presente informativa è resa ai sensi degli artt. 13 e 14 del Regolamento (UE) 2016/679
        ("GDPR") e descrive le modalità di trattamento dei dati personali degli utenti che visitano
        questo sito web del progetto "Parrucchiere Vincente" e che utilizzano il modulo di contatto.
      </p>

      <h2>1. Titolare del trattamento</h2>
      <p>
        <strong>BEETOO AGENCY S.R.L.</strong>
        <br />
        Sede legale: Via dell'Industria 26/B – 34144 Trieste (TS), Italia
        <br />
        P.IVA / C.F.: 01275560322 – VAT: IT01275560322 – REA: TS-137733
        <br />
        PEC: beetooagency@pec.it
      </p>
      <p>
        Per qualsiasi richiesta relativa al trattamento dei dati personali è possibile contattare il
        Titolare all'indirizzo PEC sopra indicato.
      </p>

      <h2>2. Tipologie di dati trattati</h2>
      <ul>
        <li>
          <strong>Dati forniti volontariamente tramite il modulo di contatto:</strong> nome, cognome,
          indirizzo email, numero di telefono e preferenza sull'orario di contatto.
        </li>
        <li>
          <strong>Dati di navigazione:</strong> indirizzo IP, tipo di browser e dispositivo, pagine
          visitate, interazioni con i contenuti del sito (es. percentuale di visualizzazione dei video),
          identificatori tecnici (cookie _fbp, _fbc) e parametri di provenienza della visita
          (parametri UTM, identificativi di campagne pubblicitarie, fbclid).
        </li>
      </ul>

      <h2>3. Finalità e basi giuridiche del trattamento</h2>
      <table>
        <thead>
          <tr>
            <th>Finalità</th>
            <th>Base giuridica</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              Ricontatto dell'utente che ha compilato il modulo, tramite telefono e WhatsApp, per fornire
              informazioni sul servizio richiesto
            </td>
            <td>Esecuzione di misure precontrattuali adottate su richiesta dell'interessato (art. 6.1.b GDPR)</td>
          </tr>
          <tr>
            <td>
              Trasmissione dei dati del modulo a un foglio di lavoro interno (Google Sheets, tramite la
              piattaforma di automazione Make) per la gestione organizzata delle richieste
            </td>
            <td>Legittimo interesse del Titolare alla gestione efficiente delle richieste (art. 6.1.f GDPR)</td>
          </tr>
          <tr>
            <td>
              Misurazione delle conversioni e delle interazioni sul sito tramite Meta Pixel e Meta
              Conversions API (eventi come visualizzazione pagina, visualizzazione video, click sui
              pulsanti, invio del modulo)
            </td>
            <td>Consenso dell'interessato (art. 6.1.a GDPR), prestato tramite il banner cookie</td>
          </tr>
          <tr>
            <td>
              Creazione di pubblici personalizzati e attività di retargeting pubblicitario sulle
              piattaforme Meta (Facebook/Instagram), TikTok, YouTube e Google
            </td>
            <td>Consenso dell'interessato (art. 6.1.a GDPR)</td>
          </tr>
          <tr>
            <td>Tracciamento della provenienza pubblicitaria della richiesta (campagna, gruppo di inserzioni, creatività)</td>
            <td>Legittimo interesse del Titolare alla misurazione dell'efficacia delle proprie campagne (art. 6.1.f GDPR)</td>
          </tr>
        </tbody>
      </table>

      <h2>4. Modalità del trattamento e destinatari</h2>
      <p>
        I dati sono trattati con strumenti elettronici e misure di sicurezza adeguate. I dati possono
        essere comunicati a:
      </p>
      <ul>
        <li>
          <strong>Meta Platforms Ireland Ltd.</strong> – per la misurazione delle conversioni (Meta
          Pixel e Conversions API) e per la creazione di pubblici personalizzati. I dati di contatto
          trasmessi lato server sono sottoposti a pseudonimizzazione (hashing SHA-256) prima dell'invio.
        </li>
        <li>
          <strong>Make (Celonis / Make.com)</strong> e <strong>Google LLC (Google Sheets)</strong> – per
          l'archiviazione organizzata delle richieste di contatto.
        </li>
        <li>
          <strong>TikTok, Google/YouTube</strong> – esclusivamente nell'ambito di eventuali attività di
          retargeting basate sul consenso.
        </li>
        <li>Fornitori di servizi di hosting e infrastruttura tecnica del sito.</li>
      </ul>
      <p>
        Alcuni destinatari possono trovarsi al di fuori dello Spazio Economico Europeo; in tali casi il
        trasferimento avviene sulla base di Clausole Contrattuali Standard approvate dalla Commissione
        Europea o del EU-US Data Privacy Framework.
      </p>

      <h2>5. Periodo di conservazione</h2>
      <ul>
        <li>Dati del modulo di contatto: fino a 24 mesi dalla raccolta, salvo instaurazione di un rapporto contrattuale.</li>
        <li>Dati di tracciamento pubblicitario: secondo i termini indicati nella Cookie Policy e nelle policy delle rispettive piattaforme.</li>
      </ul>

      <h2>6. Natura del conferimento</h2>
      <p>
        Il conferimento dei dati richiesti nel modulo di contatto è necessario per poter essere
        ricontattati: il mancato conferimento rende impossibile dar seguito alla richiesta. Il consenso
        ai cookie di marketing è invece facoltativo e la sua mancata prestazione non pregiudica la
        navigazione del sito né l'invio del modulo.
      </p>

      <h2>7. Diritti dell'interessato</h2>
      <p>Ai sensi degli artt. 15-22 GDPR, l'interessato ha diritto di:</p>
      <ul>
        <li>ottenere l'accesso ai propri dati personali e le informazioni sul trattamento;</li>
        <li>chiederne la rettifica, la cancellazione o la limitazione del trattamento;</li>
        <li>opporsi al trattamento basato sul legittimo interesse, incluse le finalità di marketing;</li>
        <li>revocare in qualsiasi momento il consenso prestato, senza pregiudicare la liceità del trattamento precedente;</li>
        <li>richiedere la portabilità dei dati;</li>
        <li>proporre reclamo al Garante per la Protezione dei Dati Personali (www.garanteprivacy.it).</li>
      </ul>
      <p>
        Le richieste possono essere inviate a: <strong>beetooagency@pec.it</strong>. La revoca del
        consenso ai cookie può essere effettuata in autonomia tramite il pulsante "Gestisci consenso
        cookie" presente nel footer del sito.
      </p>

      <h2>8. Processi decisionali automatizzati</h2>
      <p>
        Il Titolare non effettua processi decisionali automatizzati che producano effetti giuridici
        sugli interessati. Le piattaforme pubblicitarie possono utilizzare i dati raccolti, previo
        consenso, per la personalizzazione degli annunci secondo le proprie logiche.
      </p>

      <h2>9. Modifiche alla presente informativa</h2>
      <p>
        Il Titolare si riserva il diritto di modificare la presente informativa. Le modifiche saranno
        pubblicate su questa pagina con indicazione della data di aggiornamento.
      </p>
    </LegalLayout>
  );
}
